import { render, staticRenderFns } from "./incubatorDetail.vue?vue&type=template&id=5d6b2102&scoped=true&"
import script from "./incubatorDetail.vue?vue&type=script&lang=js&"
export * from "./incubatorDetail.vue?vue&type=script&lang=js&"
import style0 from "./incubatorDetail.vue?vue&type=style&index=0&id=5d6b2102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b2102",
  null
  
)

export default component.exports